<template>
    <div>
        <div class="w3-row">
            <div class="w3-col w3-threequarter">
                <content-header v-bind:title="patientHeading"></content-header>
                <span v-if="device">
                    <i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left" :title="$t('loggedIn')"></i>
                </span>
            </div>
            <div class="w3-col w3-quarter w3-right flow-padding-top w3-large" v-if="!isDH">
                        <span class="fa fa-stack cursor-pointer w3-right flow-form-action active w3-ripple flow-blue-color w3-margin-right"
                              v-if="!isNormal"
                              @click="openPatientsPage"
                              :title="$t('patientsOverview')">
                            <i class="fa fa-stack-2x fa-circle  w3-text-white"></i>
                            <i class="fa fa-stack-1x fa-users fa-inverse flow-blue-color w3-xlarge"></i>
                        </span>
            </div>
        </div>
        <br>

        <div class="flow-main-content">
            <div class=" w3-container zero">
                <div class="w3-container w3-cell flow-padding-right w-70pc  flow-card">
                    <patient-info></patient-info>
                </div>
                <div class="w3-container w3-cell flow-padding-right w-5pc"></div>
                <div class="w3-container w3-cell w3-center w-25pc zero flow-card ">
                    <patient-personal-data></patient-personal-data>
                </div>
            </div>
            <div class="w3-container zero w3-margin-top flow-padding-top flow-card w3-padding">
                <patient-appt></patient-appt>
            </div>
        </div>

    </div>
</template>
<script>
    import Vue from "vue"
    import ContentHeader from "../components/common/ContentHeader";
    import Loading from "../components/common/Loading";
    import PatientInfo from "../components/patient/PatientInfo";
    import PatientAppt from "../components/patient/PatientAppointment";
    import PatientPersonalData from "../components/patient/PatientPersonalData";

    var frc = Vue.prototype.$frc;

    export default {
        name: "Patient",
        components: {Loading, ContentHeader, PatientInfo, PatientAppt, PatientPersonalData},
        props: ['ftitle'],
        data: function () {
            return {
                contentLoaded: false,
                patient: {},
                ids: [],
                name: '',
                device: null
            }
        },
        computed: {
            patientHeading: function () {
                return Vue.patientNamePlusId(this.name, this.ids);
            },

            isNormal() {
                return Vue.isNormal(Vue.prototype.$currentUser.user.role);
            },
            isDH() {
                return Vue.prototype.$showStatusOverviewMenu;
            }
        },
        methods: {
            openPatientsPage: function () {
                this.$router.push("/patients");
            }

        },
        beforeCreate() {
            var app = this;
            frc.getPatient(this.$route.params.id).then(function (res) {
                app.patient = res.data;
                app.name = res.data.name;
                app.ids = res.data.internalIds;
                app.device = Vue.getValueForKey(res.data.properties.entry, 'device');
            })
        }
    }

</script>

<style scoped>

</style>